import React from 'react'
import { Helmet } from 'react-helmet'
import './support-maintenance.css';

function SupportAndMaintenance() {
    return (
        <>

            {/* Helmet for SEO */}
            <Helmet>
                <title>Software Support and Maintenance | ERA Automation & Software</title>
                <meta
                    name="description"
                    content="Ensure your software runs smoothly with expert software support and maintenance services. We provide tailored solutions to keep your systems up-to-date, secure, and running efficiently."
                />
                <meta
                    name="keywords"
                    content="Software Support, Software Maintenance, IT Support, Software Optimization, ERA Automation, software maintenance services, software support services, ongoing software support, IT maintenance services, software update services, software optimization, application maintenance, system monitoring and support, software bug fixing, IT support and maintenance"
                />
            </Helmet>


            <div>
                {/* page-1 */}

                <div className="w-screen h-screen bg-black flex items-center justify-center">
                    <div className="text-center px-6 py-12 max-w-2xl w-full support-wrap">
                        <h1 className="text-6xl font-bold uppercase text-white leading-tight ">
                            Software Support and Maintenance
                        </h1>
                        <p className="mt-6 text-xl text-gray-400 max-w-2xl mx-auto text-center">
                            At ERA Automation & Software, we understand that reliable software is critical to your business. Our tailored <span className="font-semibold">support</span> and <span className="font-semibold">maintenance</span> services ensure your software stays secure, efficient, and up-to-date—minimizing downtime and optimizing performance.
                        </p>
                        <p className="mt-4 text-xl font-light italic text-gray-600">
                            Comprehensive, proactive support designed to keep your software running smoothly, so you can focus on growth.
                        </p>
                    </div>
                </div>


                {/* PAGE-2 */}
                <div className="w-full h-screen py-12 support-page1 justify-center items-center grid">
                    <div className="text-center px-6 max-w-3xl mx-auto ">
                        <h2 className="text-3xl font-semibold text-gray-800 support-title">Our Comprehensive Software Support and Maintenance Services</h2>

                        <p className="mt-6 text-lg text-gray-700 support-description">
                            Our software support and maintenance services are designed to ensure that your business operates smoothly. Here’s how we can help:
                        </p>
                        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="bg-white p-6 shadow-md rounded-md">
                                <h3 className="text-2xl font-semibold text-gray-800 support-middle-title">Ongoing Support</h3>
                                <p className="mt-2 text-gray-600">
                                    Our team provides continuous support, ensuring your software stays secure, bug-free, and up-to-date.
                                </p>
                            </div>
                            <div className="bg-white p-6 shadow-md rounded-md">
                                <h3 className="text-2xl font-semibold text-gray-800 support-middle-title">System Maintenance</h3>
                                <p className="mt-2 text-gray-600">
                                    We offer regular system maintenance, including updates and performance tuning to keep your software optimized.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center px-6 max-w-3xl mx-auto pt-24">
                        <h2 className="uppercase font-semibold text-3xl py-4 support-title">Why Software Support and Maintenance Matter</h2>
                        <p className="text-lg mt-4 support-description">
                            Regular software support and maintenance are critical to avoid interruptions, minimize risks, and
                            maintain optimal performance. Whether you’re facing technical challenges, need performance tuning,
                            or want to stay up-to-date with the latest features, our services ensure your business runs without
                            a hitch.
                        </p>
                    </div>
                </div>




                {/* page-3 */}

                <div className='w-screen h-full flex flex-col items-center justify-center bg-black text-white'>
                    <div className='p-10 w-full max-w-3xl text-center'>
                        <h1 className='uppercase font-semibold text-4xl py-4 support-title'>Software Support and Maintenance Services</h1>
                    </div>

                    <div className='p-10 w-full max-w-3xl text-center'>
                        <h2 className='uppercase font-semibold text-3xl py-4 support-title'>Software Support</h2>
                        <p className='text-xl text-gray-300 support-description'>Our dedicated team provides comprehensive support to resolve issues quickly and efficiently.</p> <br />
                        <ul className='text-xl text-gray-300 support-description'>
                            <li><span className='font-bold leading-loose'>Real-time Issue Resolution:</span> We address problems as they arise to minimize downtime.</li>
                            <li><span className='font-bold leading-loose'>Customized Solutions:</span> Every business is unique, and so are our solutions.</li>
                            <li><span className='font-bold leading-loose'>Guidance and Training:</span> Empowering your team to use software effectively.</li>
                        </ul>

                        <p className='text-xl support-description'>Funny One-Liner: Think of us as your software’s personal butler, always ready to help!</p>
                    </div>

                    <div className='p-10 w-full max-w-3xl text-center'>
                        <h2 className='uppercase font-semibold text-3xl py-4 support-title'>Software Maintenance</h2>
                        <p className='text-xl  text-gray-300 support-description'>Software needs consistent care to keep up with the demands of modern business.</p> <br />
                        <ul className='text-xl text-gray-300 support-description'>
                            <li><span className='font-bold leading-loose'>Regular Updates:</span> Stay ahead with the latest security patches and features.</li>
                            <li><span className='font-bold leading-loose'>Performance Optimization:</span> Faster, smoother, and better—every time.</li>
                            <li><span className='font-bold leading-loose'>Proactive Monitoring:</span> Identify and fix potential issues before they impact you.</li>
                            <li><span className='font-bold leading-loose'>Security Enhancements:</span> Protect your business from ever-evolving threats.</li>
                        </ul> <br />
                        <p className='text-xl text-gray-300 support-description'><span className='font-bold leading-loose'>Funny One-Liner:</span> Keeping your software in tip-top shape, like a tech-savvy fairy godmother!</p>
                    </div>
                </div>

                {/* page-4 */}

                <div className='w-screen h-full flex flex-col items-center justify-center py-10'>
                    <div className='p-10 w-full max-w-3xl text-center'>
                        <h1 className='uppercase font-semibold text-4xl py-4 support-title'>Our Approach</h1>
                        <p className='text-xl leading-loose support-description'>We believe in providing services tailored to your needs. Here’s how we work:</p> <br />

                        <p className='text-xl leading-loose support-description'><span className='font-bold'>Initial Consultation:</span> We learn about your software, challenges, and goals.</p>
                        <p className='text-xl leading-loose support-description'> <span className='font-bold'>Assessment:</span> An in-depth evaluation to identify areas of improvement.</p>
                        <p className='text-xl leading-loose support-description'><span className='font-bold'>Action Plan:</span> Customized strategies for support and maintenance.</p>
                        <p className='text-xl leading-loose support-description'> <span className='font-bold'>Ongoing Care:</span> Continuous monitoring, updates, and improvements.</p>
                    </div>
                    <div className='p-10 w-full max-w-3xl text-center'>
                        <h1 className='uppercase font-semibold text-4xl py-4 support-title'>Why Choose ERA Automation & Software?</h1>
                        <ul className='text-xl list-disc list-inside leading-loose support-description'>
                            <li>Expertise in diverse software platforms.</li>
                            <li>A proactive, problem-solving approach.</li>
                            <li>Affordable solutions for businesses of all sizes.</li>
                            <li>Commitment to building long-term relationships.</li>
                        </ul>
                    </div>


                    <div className='p-10 w-full max-w-3xl text-center'>
                        <h1 className='uppercase font-semibold text-4xl py-4 support-title'>Let’s Get Started!</h1>
                        <p className='text-xl support-description'>Whether you’re a startup or an established business, we’re ready to provide the support and care your software needs.</p> <br />
                        <p className='text-xl py-4 support-description'><span className='font-bold'>Call-to-Action:</span> "Contact us today to learn more about our services and how we can support your business."</p>
                    </div>
                </div>


            </div>
        </>
    )
}
export default SupportAndMaintenance;